import {
	AccountTypes,
	getAgencyKey,
	getApplicationHeaders,
	httpClient,
	UserTypes,
} from "@utils";

export class GracePeriodApiService {
	static baseUrl = (activeAccount: UserTypes = UserTypes.PRIMARY) => {
		return `${WEBPACK_BASE_ADDRESS}${getAgencyKey(
			activeAccount
		)}/gp-users/confirm-grace-period`;
	};

	static getRequestHeaders(activeUser = UserTypes.PRIMARY) {
		const appHeaders = getApplicationHeaders(activeUser);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	}

	static async confirmGracePeriod(): Promise<void> {
		const activeUser = App.state.rootStore.userAuthStore.getUserAccountType(
			AccountTypes.ONLINE
		);

		return await httpClient.post(
			`${this.baseUrl(activeUser)}`,
			null,
			this.getRequestHeaders(activeUser),
			{ responseType: "text" }
		);
	}
}
